import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import Sidebar from "../../../core/common/sidebar/sidebar";
import { Link } from "react-router-dom";
import DeleteReviewModal from "./deleteReviewModal";
import axios from "axios";

// Import do Lightbox
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

type FotoPorPontoDTO = {
  fotoId: number;
  ponto: string;
  url: string;
};

type AvaliacaoDTO = {
  id: number;
  nota: number;
  comentario: string;
  usuarioNome: string;
  usuarioFotoUrl?: string;
  pacoteNome?: string;
  motoristaNome?: string;
  status: string;
  fotos?: number[];
  fotosPorPonto?: FotoPorPontoDTO[];
};

const UserReviews = () => {
  const routes = all_routes;
  const BASE_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const [reviews, setReviews] = useState<AvaliacaoDTO[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedReviewId, setSelectedReviewId] = useState<number | null>(null);

  // Lightbox
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [lightboxSlides, setLightboxSlides] = useState<{ src: string }[]>(
    []
  );

  const breadcrumbs = [
    { label: "My Reviews", link: routes.home1, active: false },
    { label: "My Reviews", active: true },
  ];

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await axios.get<AvaliacaoDTO[]>(
          `${BASE_URL}/avaliacoes/meus`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setReviews(res.data);
      } catch (err) {
        console.error("Erro ao carregar avaliações:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchReviews();
  }, [token, BASE_URL]);

  return (
    <div>
      <Breadcrumb
        title="My Reviews"
        breadcrumbs={breadcrumbs}
        backgroundClass="breadcrumb-bg-01"
      />

      <div className="content">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-xl-3 col-lg-4">
              <Sidebar />
            </div>

            <div className="col-xl-9 col-lg-8">
              {/* Card com número de reviews e texto de edição */}
              <div className="card">
                <div className="card-body d-flex justify-content-between align-items-center">
                  <div>
                    <h6>My Reviews</h6>
                    <p className="fs-14">No of Reviews : {reviews.length}</p>
                  </div>
                  <span className="text-muted small">
                    To edit one of your reviews, please go to the Bookings page.
                  </span>
                </div>
              </div>

              {/* Reviews */}
              {loading ? (
                <p>Loading reviews...</p>
              ) : reviews.length === 0 ? (
                <div className="alert alert-info mt-3">
                  You haven’t written any reviews yet.
                </div>
              ) : (
                reviews.map((r) => (
                  <div key={r.id} className="card review-item shadow-none mb-3">
                    <div className="card-body p-3">
                      <div className="review-info">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                          <div className="d-flex align-items-center mb-2">
                            <span className="avatar avatar-lg me-3 flex-shrink-0">
                              <img
                                src={
                                  r.usuarioFotoUrl
                                    ? `${BASE_URL}${r.usuarioFotoUrl}`
                                    : "/assets/img/users/default-avatar.png"
                                }
                                className="rounded-circle"
                                alt={r.usuarioNome}
                              />
                            </span>
                            <div>
                              <h6 className="fs-16 fw-medium mb-1">
                                {r.usuarioNome}
                              </h6>
                              <div className="d-flex align-items-center flex-wrap date-info">
                                <p className="fs-14 mb-1 d-inline-flex align-items-center">
                                  <span className="badge badge-warning badge-xs text-gray-9 fs-13 fw-medium me-2 d-inline-flex align-items-center">
                                    <i className="isax isax-star" /> {r.nota}
                                  </span>
                                  <span
                                    style={{
                                      color: "#333",
                                      fontSize: "0.95rem",
                                      lineHeight: 1.5,
                                    }}
                                  >
                                    {r.comentario || ""}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>

                          {/* Botão Delete */}
                          <div className="d-flex align-items-center">
                            <button
                              className="btn btn-white btn-sm border"
                              onClick={() => setSelectedReviewId(r.id)}
                              data-bs-toggle="modal"
                              data-bs-target="#delete_modal"
                            >
                              <i className="isax isax-trash me-1" />
                              Delete
                            </button>
                          </div>
                        </div>

                        {/* Fotos da avaliação */}
                        {((r.fotosPorPonto?.length ?? 0) > 0 ||
                          (r.fotos?.length ?? 0) > 0) && (
                            <div className="d-flex align-items-center flex-wrap mt-3 mb-2">
                              {/* Fotos por ponto */}
                              {r.fotosPorPonto?.map((f) => (
                                <div
                                  key={`ponto-${f.fotoId}`}
                                  className="me-3 mb-3 position-relative"
                                  style={{
                                    width: "90px",
                                    height: "90px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    const todasFotos = [
                                      ...(r.fotos?.map((fid) => ({
                                        src: `${BASE_URL}/uploads/${fid}`,
                                      })) || []),
                                      ...(r.fotosPorPonto?.map((fp) => ({
                                        src: `${BASE_URL}${fp.url}`,
                                      })) || []),
                                    ];
                                    const index = todasFotos.findIndex(
                                      (img) => img.src === `${BASE_URL}${f.url}`
                                    );

                                    setLightboxSlides(todasFotos);
                                    setLightboxIndex(index >= 0 ? index : 0);
                                    setLightboxOpen(true);
                                  }}
                                >
                                  <img
                                    src={`${BASE_URL}${f.url}`}
                                    alt={f.ponto || "foto do ponto"}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                    }}
                                  />
                                  <div
                                    className="position-absolute bottom-0 start-0 w-100 text-center text-white px-1"
                                    style={{
                                      background: "rgba(0,0,0,0.55)",
                                      fontSize: "0.7rem",
                                      borderBottomLeftRadius: "8px",
                                      borderBottomRightRadius: "8px",
                                    }}
                                  >
                                    {f.ponto}
                                  </div>
                                </div>
                              ))}

                              {/* Fotos gerais */}
                              {r.fotos?.map((fid) => (
                                <div
                                  key={`foto-${fid}`}
                                  className="me-3 mb-3"
                                  style={{
                                    width: "90px",
                                    height: "90px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    const todasFotos = [
                                      ...(r.fotos?.map((fid2) => ({
                                        src: `${BASE_URL}/uploads/${fid2}`,
                                      })) || []),
                                      ...(r.fotosPorPonto?.map((fp) => ({
                                        src: `${BASE_URL}${fp.url}`,
                                      })) || []),
                                    ];
                                    const index = todasFotos.findIndex(
                                      (img) =>
                                        img.src ===
                                        `${BASE_URL}/uploads/${fid}`
                                    );

                                    setLightboxSlides(todasFotos);
                                    setLightboxIndex(index >= 0 ? index : 0);
                                    setLightboxOpen(true);
                                  }}
                                >
                                  <img
                                    src={`${BASE_URL}/uploads/${fid}`}
                                    alt="foto da avaliação"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          )}

                        {/* Info extra */}
                        <div className="d-flex justify-content-between align-items-center flex-wrap row-gap-2">
                          <p className="fs-14 d-flex align-items-center mb-0">
                            <i className="isax isax-info-circle5 text-gray-9 me-2" />
                            Info : {r.pacoteNome || "Pacote"}{" "}
                            {r.motoristaNome
                              ? `(Driver: ${r.motoristaNome})`
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      <DeleteReviewModal
        selectedReviewId={selectedReviewId}
        onDelete={(id) => setReviews(reviews.filter(r => r.id !== id))}
        BASE_URL={BASE_URL!}
      />


      {/* Lightbox */}
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={lightboxSlides}
        index={lightboxIndex}
        on={{
          view: ({ index }) => setLightboxIndex(index),
        }}
      />
    </div>
  );
};

export default UserReviews;